/* eslint eqeqeq: "off" */
import React from "react";
import { Col, Row, Image } from "antd";
import { RightOutlined } from "@ant-design/icons";
import ScenicWonder1 from "../../assets/images/scenic-wonders/scenic-wonder-3.jpg";
import ScenicWonder2 from "../../assets/images/scenic-wonders/scenic wonder-2.jpg";
import ScenicWonder3 from "../../assets/images/scenic-wonders/scenic-wonder-4.jpg";
import ScenicWonder4 from "../../assets/images/scenic-wonders/scenic-wonders.jpg";
// import Saudi from "../../assets/images/landing/saudi.jpg";
import "./index.css";
import useMedia from "use-media-antd-query";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Wonders = () => {
  const media = useMedia();

  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          // display: block;
          background: "rgba(8, 3, 3, 0.83)",
          height: "30px",
          borderRadius: "40px",
          width: "30px",
          padding: "6px",
          fontWeight: "700",
          marginRight: "20px",
          marginTop: "-30px",
          zIndex: 10,
        }}
        onClick={onClick}
      >
        <RightOutlined className="text-[10px]" />
      </div>
    );
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          background: "rgba(8, 3, 3, 0.83)",
          height: "30px",
          borderRadius: "40px",
          width: "30px",
          padding: "6px",
          fontWeight: "700",
          marginLeft: "20px",
          marginTop: "-30px",
          fontSize: "12px",
          zIndex: 10,
        }}
        onClick={onClick}
      />
    );
  }

  const slides = [
    {
      id: 1,
      content: (
        <Image
          preview={false}
          src={ScenicWonder1}
          height={
            media == "sm"
              ? 180
              : media == "xs"
              ? 200
              : media == "md"
              ? 180
              : 150
          }
          className="border border-solid rounded-xl"
          width={"100%"}
        />
      ),
      title: "Malaysia",

      startingPrice: "30,000 /-",
    },
    {
      id: 2,
      content: (
        <Image
          preview={false}
          src={ScenicWonder2}
          height={
            media == "sm"
              ? 180
              : media == "xs"
              ? 200
              : media == "md"
              ? 180
              : 150
          }
          className="border border-solid rounded-xl"
          width={"100%"}
        />
      ),
      title: "Bangkok",
      startingPrice: "35,000 /-",
    },
    {
      id: 3,
      content: (
        <Image
          preview={false}
          src={ScenicWonder3}
          height={
            media == "sm"
              ? 180
              : media == "xs"
              ? 200
              : media == "md"
              ? 180
              : 150
          }
          className="border border-solid rounded-xl"
          width={"100%"}
        />
      ),
      title: "Himachal",
      startingPrice: "12,000 /-",
    },
    {
      id: 4,
      content: (
        <Image
          preview={false}
          src={ScenicWonder4}
          height={
            media == "sm"
              ? 180
              : media == "xs"
              ? 200
              : media == "md"
              ? 180
              : 150
          }
          className="border border-solid rounded-xl"
          width={"100%"}
        />
      ),
      title: "Kashmir",
      startingPrice: "15,000 /-",
    },
  ];

  const settings = {
    // className: "center",
    centerMode: true,
    // dots: true, // Show navigation dots
    infinite: slides && slides.length > 1,
    centerPadding: "3px",
    slidesToShow: 1,
    // fade: true,
    // speed: 1200,
    // autoplay: true,
    // autoplaySpeed: 2200,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    // slidesToScroll: 1,
    // cssEase: "linear",
  };

  return (
    <React.Fragment>
      <Col md={24} sm={24} lg={24} xl={24} xxl={24}>
        <Row>
          <Col
            md={24}
            sm={24}
            lg={24}
            xl={24}
            xxl={24}
            className={
              media == "sm" || media == "xs"
                ? "pt-3 pb-3 pl-[40px] pr-[40px]"
                : "pt-3 pb-3 pl-[80px] pr-[80px]"
            }
          >
            <div
              style={{
                // width: "100%",
                marginTop: "2px",
              }}
            >
              <Slider {...settings} centerMode className="h-[100%]">
                {slides.map((slide) => (
                  <div
                    style={
                      {
                        //   background: "rgb(163 163 163 / 5%)",
                        //   position: "relative",
                        //   zindex: "100",
                        //   height: "100%",
                        //   borderRadius: "10px",
                      }
                    }
                    key={slide.id}
                    className="relative h-[200px] pr-2 pl-2"
                  >
                    <h2 className="text-[black]">{slide.content}</h2>
                    {/* <div className="h-[100px] z-10"> */}
                    <div className="z-10 w-[100%]">
                      <p
                        style={{
                          position: "absolute",
                          top: "0px",
                          bottom: "50px",
                          right: "9px",
                          left: "9px",
                          //   marginLeft: "1px",
                          //   width: '100px',
                          color: "white",
                          fontSize: "18px",
                          fontFamily: "Poppins",
                          fontWeight: 700,
                          //   zIndex: 20,
                          padding: "20px",
                          background:
                            media == "sm" || media == "xs" ? "" : "#63636361",
                          borderRadius: "12px",
                        }}
                      ></p>
                      <div
                        style={{
                          position: "absolute",
                          //   left: "20px",
                          top: "0px",
                          bottom: "50px",
                          marginLeft: "1px",
                          //   background: "#0006",
                          color: "#000000",
                          // color: "#ffffff",
                          //   background: "#0006",
                          fontSize: "14px",
                          borderRadius: "10px",
                          fontWeight: 700,
                          zIndex: 20,
                          padding: "20px 20px",
                          fontFamily: "Poppins",
                          //   borderTopLeftRadius: "8px",
                          //   borderTopRightRadius: "8px",
                        }}
                        className={
                          media == "sm" || media == "xs" || media == "md"
                            ? "flex flex-col"
                            : "flex justify-between"
                        }
                      >
                        <div
                          className={
                            media == "sm" || media == "xs" || media == "md"
                              ? "ml-1 bg-[#5b5b5b54] rounded-lg pl-2 pr-2"
                              : "ml-[70px] bg-[#5b5b5b54] rounded-lg pl-2 pr-2"
                          }
                        >
                          <h1
                            style={{
                              fontFamily: "Poppins",
                            }}
                            className={
                              media == "sm"
                                ? "uppercase text-lg font-extrabold"
                                : media == "xs"
                                ? "uppercase text-md font-extrabold"
                                : "uppercase text-2xl font-extrabold"
                            }
                          >
                            Discover Scenic <br /> Wonders of the world
                          </h1>
                          <p
                            style={{
                              fontFamily: "Poppins",
                            }}
                            className={
                              media == "sm"
                                ? "text-lg uppercase font-extrabold"
                                : media == "xs"
                                ? "text-md uppercase font-extrabold"
                                : "text-2xl uppercase font-extrabold"
                            }
                          >
                            With Guided Tours
                          </p>
                        </div>
                        <div
                          className={
                            media == "sm" || media == "xs" || media == "md"
                              ? "mt-1 ml-1"
                              : "mt-7 ml-[150px]"
                          }
                        >
                          <div
                            className={
                              media == "sm" || media == "md"
                                ? "h-[40px] w-[70%] flex text-[14px] ml-5 mt-1"
                                : media == "xs"
                                ? "h-[40px] w-[70%] flex text-[12px] ml-5 mt-1"
                                : "h-[40px] flex text-[16px] ml-5 mt-1"
                            }
                            style={{
                              borderRadius: "15px",
                              // border: "1px",
                              padding:
                                media == "sm" || media == "xs" || media == "md"
                                  ? "4px 10px"
                                  : "4px 20px",
                              fontFamily: "Poppins",
                              background: "orange",
                              fontWeight: 800,
                              color: "white",
                              cursor: "pointer",
                            }}
                          >
                            <h1 className="mt-1">Know More</h1>
                            <RightOutlined className="text-[14px] ml-2 font-bold " />
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <div
                      style={{
                        position: "absolute",
                        //   left: "20px",
                        top: "0px",
                        bottom: "50px",
                        marginLeft: "1px",
                        background: "#0006",
                        color: "#000000",
                        // color: "#ffffff",
                        //   background: "#0006",
                        fontSize: "14px",
                        borderRadius: "10px",
                        fontWeight: 700,
                        width: "97%",
                        zIndex: 20,
                        padding: "20px 20px",
                        fontFamily: "Poppins",
                        //   borderTopLeftRadius: "8px",
                        //   borderTopRightRadius: "8px",
                      }}
                      className="flex justify-between"
                    >
                     
                    </div> */}
                    {/* </div> */}
                  </div>
                ))}
              </Slider>
            </div>
          </Col>
        </Row>
      </Col>
    </React.Fragment>
  );
};
export default Wonders;
